import React from 'react';

import useHighlightedUrl from '@swf/sports/hooks/useHighlightedUrl';

import styles from './Menu.scss';
import DefaultLink from './components/DefaultLink/DefaultLink';
import IconLink from './components/IconLink/IconLink';
import { Variant } from './types';

const Menu: React.FC = ({ children }) => {
  const highlightedUrl = useHighlightedUrl(
    React.Children.map(children, (child) => (child as React.ReactElement).props.url) || []
  );

  return (
    <ul className={styles.list}>
      {React.Children.map(children, (child: React.ReactNode) =>
        React.cloneElement(child as React.ReactElement, {
          isActive: !(child as React.ReactElement).props.exact
            ? (child as React.ReactElement).props?.url === highlightedUrl
            : undefined
        })
      )}
    </ul>
  );
};

export { IconLink, DefaultLink, Menu, Variant };
